import { inject, Injectable } from "@angular/core";
import { HttpService } from "../../core/services";

@Injectable({
  providedIn: 'root'
})
export class BugReportApi {
  private readonly httpService = inject(HttpService);

  listBugReports() {
    return this.httpService.get("bug-reports", false);
  }

  createBugReport(payload: FormData) {
    return this.httpService.postForm("bug-reports", payload, false);
  }

  updateBugReportStatus(id: string, status: 'open' | 'closed') {
    return this.httpService.put(`bug-reports/${id}/status`, { status }, false);
  }
}
